import { cn } from '@/lib/utils';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';

import {
  friendlyTooltip,
  lanceStatusCategory,
  type LanceCategory,
  type LanceStatus,
} from '@motor/statusLance.ts';

export { friendlyTooltip, lanceStatusCategory };
export type { LanceCategory, LanceStatus };

const categoryConfig: Record<LanceCategory, { label: string; classes: string }> = {
  ok:             { label: 'Lance: Realizado',      classes: 'bg-green-100 text-green-800 border-green-200' },
  contemplado:    { label: 'Contemplado',           classes: 'bg-[#FBE3A6] text-[#8A4F00] border-[#EFC563]' },
  pendente:       { label: 'Lance: Pendente',       classes: 'bg-slate-100 text-slate-700 border-slate-200' },
  falha:          { label: 'Lance: Falha',          classes: 'bg-red-100 text-red-800 border-red-200' },
  nao_disponivel: { label: 'Lance: Não disponível', classes: 'bg-amber-100 text-amber-800 border-amber-200' },
};

export type LanceStatusBadgeProps = {
  status: LanceStatus;
  /** error_message do servopa_lances. Usado pra montar tooltip amigável. */
  tooltip?: string | null;
  className?: string;
  /** Clique no badge (ex.: abrir a Contemplação filtrada na cota). Com ele o
   *  badge vira botão; o stopPropagation é daqui, porque o badge vive dentro
   *  de cards que também navegam ao clique. */
  onClick?: () => void;
};


export const LanceStatusBadge = ({ status, tooltip, className, onClick }: LanceStatusBadgeProps) => {
  const category = lanceStatusCategory(status);
  const c = categoryConfig[category];
  const friendly = friendlyTooltip(tooltip);

  const classes = cn(
    'inline-block px-2 py-0.5 rounded text-[10px] font-semibold border whitespace-nowrap',
    onClick ? 'cursor-pointer hover:ring-1 hover:ring-primary/40' : 'cursor-help',
    c.classes,
    category === 'contemplado' && 'lance-shine',
    className,
  );

  const badge = onClick ? (
    <button
      type="button"
      title="Abrir na Contemplação"
      onClick={(e) => {
        e.stopPropagation();
        onClick();
      }}
      className={classes}
    >
      {c.label}
    </button>
  ) : (
    <span className={classes}>{c.label}</span>
  );

  // Sem mensagem extra → renderiza só o badge (sem tooltip vazio).
  if (!friendly) return badge;

  return (
    <Tooltip>
      <TooltipTrigger asChild>{badge}</TooltipTrigger>
      <TooltipContent side="top" className="max-w-xs">
        {friendly}
      </TooltipContent>
    </Tooltip>
  );
};
